<!--全屏上中下三分布局组件，body部分高度自适应-->
<template>
    <div class="wt-col">
        <div class="wt-col__head">
            <slot name="head" />
        </div>
        <div class="wt-col__body" :class="{'wt-col__body--scroll':scroll}">
            <slot />
        </div>
        <div class="wt-col__footer">
            <slot name="footer" />
        </div>
    </div>
</template>

<script>
export default {
  name: 'wt-col',
  props: {
    // 设置body区域是否可滚动，如果为false,那么footer部分可能会被往下挤。如果设置为true,那么footer会始终停留在父容器底部，body会出现滚动条。
    scroll: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less">
.wt-col{
    display:flex;
    flex-direction: column;
    height:100%;
    &__body{
        flex:1;
        &--scroll{
            overflow-y:auto;
            -webkit-overflow-scrolling: touch;
        }
    }
    &__footer{
        height:auto;
    }
}
</style>
